import { render, staticRenderFns } from "./NewLogin.vue?vue&type=template&id=7805f989&scoped=true&"
import script from "./NewLogin.vue?vue&type=script&lang=js&"
export * from "./NewLogin.vue?vue&type=script&lang=js&"
import style0 from "./NewLogin.vue?vue&type=style&index=0&id=7805f989&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7805f989",
  null
  
)

export default component.exports